import { isMobile, gameConfigStore } from '@pascal/pascal-core';
import { containerNames } from '../../enums/containerNames';
import { PixiBase } from '../../core/pixi/PixiBase';
import { gameResourceNames } from '../../core/pixi/resources';
import { Spine } from '../../services/spine';
import { mobileGameConfigs } from '../../core/pixi/config';
import { brandedGameNameDependOnIds } from '../../enums/brandedPartners';

let intervalId = null;
let timeOutId = null;
export class TransitionDrawer {
  constructor() {
    this.animations = {};
    this.transitionContainer = PixiBase.createContainer(containerNames.transitionContainer);
  }

  setupBackground() {
    const { gameId } = gameConfigStore;
    if (brandedGameNameDependOnIds[gameId]) {
      this.transition = new Spine({ key: gameResourceNames.transition });
      this.marlinFish = new Spine({ key: gameResourceNames.marlinFish });
      const { width, height } = mobileGameConfigs;

      const spinePositionWeb = { x: 276, y: 333 };
      const spinePositionMobile = { x: width / 2, y: height / 2 };

      if (isMobile()) {
        PixiBase.setPosition(this.transition, spinePositionMobile);
        PixiBase.setPosition(this.marlinFish, spinePositionMobile);
      } else {
        PixiBase.setPosition(this.transition, spinePositionWeb);
        PixiBase.setPosition(this.marlinFish, spinePositionWeb);
      }
      this.transitionContainer.addChild(this.marlinFish);
      this.transitionContainer.addChild(this.transition);
    }
  }

  playTransitionAnimation() {
    this.transition.visible = true;
    this.transition.play('animation', false, 0.75);
  }

  playMarlinFishAnimation() {
    intervalId = setInterval(() => {
      this.marlinFish && this.marlinFish.play('animation');
      timeOutId = setTimeout(() => {
        this.marlinFish && this.marlinFish.stop('animation');
      }, 4000);
    }, 20000);
  }

  resetAnimations() {
    if (this.transition) {
      this.transition.stop({ animationName: 'animation' });
      this.transition.visible = false;
    }
    if (this.marlinFish) {
      this.resetMarlinFishAnimation();
    }
  }

  resetMarlinFishAnimation() {
    timeOutId && clearTimeout(timeOutId);
    intervalId && clearInterval(intervalId);
    if (this.marlinFish) {
      this.marlinFish.stop('animation');
    }
    timeOutId = null;
    intervalId = null;
  }

  execute(config) {
    this.config = config;
    this.setupBackground();
  }
}
